module.exports = __webpack_public_path__ + "assets/btn-close-3-7936f246.png";